import { Component, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BackendApi } from '../../services/backend-api';
import { Package } from '../../models/package';
import { TextFieldModule } from '@angular/cdk/text-field';

@Component({
  selector: 'app-create-package-dialog',
  imports: [MatDialogModule, MatInputModule, MatButtonModule, MatFormFieldModule, ReactiveFormsModule, MatSelectModule, TextFieldModule],
  templateUrl: './create-package-dialog.html',
  styleUrl: './create-package-dialog.css',
})
export class CreatePackageDialog {
  constructor(
    private readonly backendApi: BackendApi,
    private dialogRef: MatDialogRef<CreatePackageDialog>
  ) { }
  
  private _snackBar = inject(MatSnackBar);
  private _formBuilder = inject(FormBuilder);

  packageTypes = [
    { value: "monthly", label: "Mensuel" },
    { value: "unlimited", label: "Illimité" }
  ];

  packageForm = this._formBuilder.group({
    name: ['', Validators.required],
    description: ['', Validators.required],
    type: ['monthly', Validators.required],
    priority_level: [0, Validators.required],
    limit: [0, Validators.required]
  })

  submit() {
    const newPackage: Package = this.packageForm.value as Package;

    // Convert hours to minutes (x60) to seconds (x60 again)
    newPackage.limit = newPackage.limit * 60 * 60;

    this.backendApi.createPackage(newPackage).subscribe({
      next: (createdPackage) => {
        this._snackBar.open("Forfait crée.");
        this.dialogRef.close(createdPackage);
      },
      error: () => {
        this._snackBar.open("Erreur rencontrée lors de la création du forfait.");
      }
    })
  }
}
